import { render, staticRenderFns } from "./goods-cate-list.vue?vue&type=template&id=581f4341"
import script from "./goods-cate-list.vue?vue&type=script&lang=js"
export * from "./goods-cate-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports